import React, { useContext, useState } from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import {
  Tabs,
  Tab,
  TabPanel,
  Link,
  PageContent,
  ListBasic,
  ListItemBasic,
  Title5,
  UtilsBlock,
} from '@hz-design-system/web-ui';
import carsTopCategoryLinks from '../../../../../../content/carsTopCategoryLinks/index.json';
import Classes from './CarsCategoryLinks.scss';
import { TCategoryItem } from '@hz-design-system/web-ui/src/types/TCategoryItem';
import EnvironmentContext from '../../../contexts/EnvironmentContext';

type TCarsCategoryLinksProps = {
  carsCategoryLinks: TCategoryItem[];
};

const CategoryLinks = ({ carsCategoryLinks }: TCarsCategoryLinksProps) => {
  const { t } = useI18nContext();
  const {
    links: { carsSearchBaseUrl },
  } = useContext(EnvironmentContext);
  const [activeTab, setActiveTab] = useState(0);

  return (
    <>
      <PageContent as="section">
        <Tabs className={Classes.Tabs} activeTab={activeTab} setActiveTab={setActiveTab}>
          <Tab label={t('cars.links.tabs.top_models')} />
          <Tab label={t('cars.links.tabs.all_brands')} />
        </Tabs>
      </PageContent>
      <UtilsBlock backgroundColor="background-default">
        <TabPanel activeTab={activeTab} tab={0} className="hz-Page-content Page-section">
          {carsTopCategoryLinks.map(({ category, models }) => (
            <ListBasic className={Classes.subList} key={category.name}>
              <ListItemBasic>
                <Title5 as="h4">
                  <Link
                    href={`${carsSearchBaseUrl}${category.url}`}
                    className="car-brand"
                    data-sem="carBrandSearchDisplayAction"
                  >
                    {category.name}
                  </Link>
                </Title5>
              </ListItemBasic>
              {models.map(({ url, name }) => (
                <ListItemBasic key={name}>
                  <Link
                    href={`${carsSearchBaseUrl}${url}`}
                    className="car-model"
                    data-sem="carModelSearchDisplayAction"
                  >
                    {name}
                  </Link>
                </ListItemBasic>
              ))}
            </ListBasic>
          ))}
        </TabPanel>
        <TabPanel activeTab={activeTab} tab={1} className="hz-Page-content Page-section">
          <ListBasic className={Classes.AllBrandsList}>
            {carsCategoryLinks.map(({ id, name, url }) => (
              <ListItemBasic key={id}>
                <Link href={url}>{name}</Link>
              </ListItemBasic>
            ))}
          </ListBasic>
        </TabPanel>
      </UtilsBlock>
    </>
  );
};

export default CategoryLinks;
